import React from "react";

function NoMatch() {
  return (
    <div>
      <h1>Page Not Found!</h1>
      <h4>Please check the URL..</h4>
    </div>
  );
}

export default NoMatch;
